import {
  fetchTokenFromPassword,
  setAccessToken,
  setRefreshToken,
} from '@vindr/utils/auth';
import { Button, ConfigProvider, Form, Input, theme } from 'antd';
import { createElement, useState } from 'react';
import { useTranslation } from 'react-i18next';

import bgImage from '../../assets/circle-map-1.png';
import logo from '../../assets/logo-light.svg';

const LoginForm = ({ onSuccess, oauth }) => {
  const { t } = useTranslation('Vindoc');
  const [form] = Form.useForm();
  const [isLoading, setIsloading] = useState(false);
  const [error, setError] = useState(null);
  const authUrl = oauth.authority + '/protocol/openid-connect/token';
  const clientId = oauth.client_id;

  const actionSave = () => {
    form
      .validateFields()
      .then(async (values) => {
        setError(null);
        setIsloading(true);
        try {
          const { username, password } = values;
          const { data } = await fetchTokenFromPassword({
            username,
            password,
            authUrl,
            clientId,
          });

          console.log(data);

          setAccessToken(data?.access_token, data?.expires_in);
          setRefreshToken(data?.refresh_token, data?.refresh_expires_in);

          onSuccess(data);
          // redirectAfterAuthentication(history);
        } catch (error) {
          console.log(error);
          if (error?.response?.data?.error_description) {
            setError('Invalid username or password');
          }
        }
        setIsloading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <ConfigProvider
      theme={{
        algorithm: theme.defaultAlgorithm,
        token: {
          fontSize: 12,
          borderRadiusSM: 2,
          borderRadiusLG: 4,
          borderRadius: 2,
          colorPrimary: '#4c80a4',
          colorText: '#000',
          colorBgBase: '#f8fafb',
          controlOutlineWidth: 0,
          fontFamily: `Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"`,
        },
      }}
    >
      <div className="flex h-screen w-screen items-center justify-center bg-secondary-dark">
        <img
          className="absolute bottom-0 right-0"
          style={{ height: '70%' }}
          src={bgImage}
        />
        <div className="-translate-y-20 rounded-sm bg-white px-5 pt-2 pb-5">
          <div className="login-form w-[300px]">
            <div className="mb-3 flex w-full justify-center">
              {createElement(logo)}
            </div>

            <Form
              form={form}
              onFinish={actionSave}
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  actionSave();
                }
              }}
              layout="vertical"
              name="edit-account"
            >
              <Form.Item
                name="username"
                label={
                  <div className="font-bold">{t('Username or Email')}</div>
                }
                className="username"
                rules={[
                  { required: true, message: 'Please input your username' },
                ]}
              >
                <Input size="large" placeholder={t('Enter Username')} />
              </Form.Item>

              <Form.Item
                name="password"
                label={<div className="font-bold">{t('Password')}</div>}
                rules={[
                  { required: true, message: 'Please input your password' },
                ]}
              >
                <Input
                  size="large"
                  placeholder={t('Enter Password')}
                  type="password"
                />
              </Form.Item>
              {error && (
                <div className="mb-3 text-center font-bold text-red-600">
                  {error}
                </div>
              )}
              <Button
                type="primary"
                className="text-md w-full font-bold"
                size="large"
                loading={isLoading}
                onClick={actionSave}
              >
                {t('LOGIN')}
              </Button>
            </Form>
          </div>
        </div>
      </div>
    </ConfigProvider>
  );
};

export default LoginForm;
